// extracted by mini-css-extract-plugin
export default {"delete":"style_delete__tj1ya"};